<template lang="pug">
  .page.event-page
    modal(
    v-if="showModal"
    :mode="modalMode"
    @close="showModal = false"
    @changeModalMode="changeModalMode"
    :modalData="modalData"
    )
    header.page__header.event-page__header.ep-header
      .ep-header__background
        img(
        :src="currentEvent.photos[0]"
        alt="Мероприятие"
        )
      .ep-header__main-header
        main-header(
        :mode="'white'"
        )
      .ep-header__main
        .event-page-container
          .ep-header__date {{ currentEvent.date_time }}
          h1.ep-header__title {{ currentEvent.title }}
          .ep-header__address {{ currentEvent.address }}
          .ep-header__button
            button.button.button_paint-main.button_long(
            @click.prevent="setShowOrderModal"
            ) Подать заявку на участие
    main.page__main
      .event-page-container
        .content
          .content__block
            p(
            v-html="currentEvent.description"
            )

    footer.page__footer
      main-footer
</template>

<script>
import { mapActions } from "vuex";
import MainHeader from "../../components/main-header/main-header";
import MainFooter from "../../components/main-footer/main-footer";
import Modal from "../../components/modal/modal";

export default {
  name: "EventPage",
  components: { Modal, MainFooter, MainHeader },
  computed: {
    eventId() {
      return this.$route.params.eventId;
    },
  },
  data() {
    return {
      showModal: false,
      modalMode: "",
      currentEvent: {
        address: "Казань",
        date_time: "2019-08-26 16:13",
        description:
          "Трудно быть боссом. Особенно это трудно в малом и среднем бизнесе, когда ты хоть и являешься владельцем компании, всё равно попадаешь в некоторую зависимость от подчинённых, их результативности и трудоспособности.",
        id: 1,
        min_age: 18,
        photos: ["https://dummyimage.com/600x400/39e36f/fff.jpg"],
        quotas: [],
        title: "Первое мероприятие",
      },
    };
  },
  methods: {
    ...mapActions(["getCurrentEvent"]),
    getData() {
      this.getCurrentEvent().then(() => {
        // this.currentEvent = res
      });
    },
    changeModalMode(mode) {
      this.modalMode = mode;
    },
    setModalData() {
      return {
        date_time: this.currentEvent.date_time,
        title: this.currentEvent.title,
        address: this.currentEvent.address,
        id: this.currentEvent.id,
      };
    },
    setShowOrderModal() {
      this.modalData = this.setModalData();
      this.showModal = true;
      this.modalMode = "ordering";
    },
  },
  mounted() {
    this.getData();
  },
};
</script>
